/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_HeadphonesInputs */

const he_home_category_headphones = /** @type {(inputs: Home_Category_HeadphonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אוזניות`)
};

const en_home_category_headphones = /** @type {(inputs: Home_Category_HeadphonesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headphones`)
};

/**
* | output |
* | --- |
* | "Headphones" |
*
* @param {Home_Category_HeadphonesInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_headphones = /** @type {((inputs?: Home_Category_HeadphonesInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_HeadphonesInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_headphones(inputs)
	return en_home_category_headphones(inputs)
});